import React from "react";
//import Spinner from "../layout/Spinner";
import PostItem from "./PostItem";
import PostVideo from "./PostVideo";
import { posts } from "./postsList";
import HScroll from "../layout/HScroll";

//rename to blog
const Posts: React.FC = () => {
  // container-wrapper blog-wrapper
  return (
    <>
      <HScroll>
        <PostVideo />
      </HScroll>
      <HScroll>
        {posts.map((post) => (
          <PostItem key={post.order} post={post} />
        ))}
      </HScroll>
    </>
  );
};

export default Posts;
